
import {ReactNode, useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger} from "../ui/dialog";

type Props = {
    children:(open: boolean, setOpen: (open: boolean) => void) => ReactNode
    headerTitle: string
    trigger: ReactNode
    triggerClassname?: string
    description?: string
    onClick?: () => void
    onClose?: () => void
    openDialog?: boolean
    setOpenDialog?: (open: boolean) => void
    triggerAsChild?: boolean

};
const DialogComponent = ({children, headerTitle, trigger, description = "", triggerClassname = "", onClose, openDialog, setOpenDialog, triggerAsChild}: Props) => {

    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (typeof openDialog === "boolean"){
            setOpen(openDialog)
        }

    }, [openDialog]);


    return (
        <Dialog open={open} onOpenChange={(open1) =>  {
            setOpen(open1)
            if (!open1) {
                onClose?.()
            }
            setOpenDialog?.(open1)
        }}>
            <DialogTrigger asChild={triggerAsChild} className={`${triggerClassname}`}>
                {trigger}
            </DialogTrigger>
            <DialogContent className="bg-white text-black">
                <DialogHeader>
                    <DialogTitle >{headerTitle}</DialogTitle>
                    <DialogDescription>
                        {description}
                    </DialogDescription>
                </DialogHeader>

                {children(open, setOpen)}
            </DialogContent>
        </Dialog>
    );
};

export default DialogComponent